<template>
  <div class="extra-style-page">
    <img src="../../assets/images/extra-style/extra-notice.jpg">
    <img src="../../assets/images/extra-style/title.jpg">
    <img class="center" src="../../assets/images/extra-style/center.png" @touchstart="hanldeViewPhoto">
    <div class="container">
      <div class="month-picker">
        <van-icon class="arrow-icon" name="arrow-down" />
        <select v-model="selectedMonth" @change="handleSelectedMonth">
          <option v-for="(item, index) in showMonthList" :key="index" :value="item">
            <span>{{ `${item}月榜单` }}</span>
          </option>
        </select>
      </div>
      <div class="content" v-if="photoList.length">
        <div class="template-wrapper" v-for="(photo, index) in photoList" :key="index">
          <photo-template :photo="photo"></photo-template>
          <div class="ranking-like">
            点赞数： {{ photo.supportCount }}
            <img src="../../assets/images/extra-style/like.png">
          </div>
          <div class="ranking-client">用户名： {{ photo.clientCode }}</div>
        </div>
      </div>
      <div class="content no-data" v-else>
        暂无数据
      </div>
      <div class="return-btn">
        <img src="../../assets/images/extra-style/return.png" @touchstart="hanldeReturnIndex">
      </div>
    </div>
  </div>
</template>

<script>
import PhotoTemplate from './components/photo-template'
import extraStyleApi from '@/api/extra-style'
// import { userUtils } from '@/utils/auth'
export default {
  name: 'ExtraStyleRanking',
  components: {
    PhotoTemplate
  },
  data () {
    return {
      userInfo: null,
      photoList: [],
      allMonthList: ['1-3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      showMonthList: [],
      selectedMonth: ''
    }
  },
  created () {
    this.queryPhotoList()
    this.initData()
  },
  methods: {
    queryPhotoList () {
      const currentMonth = new Date().getMonth() + 1
      const month = this.selectedMonth === '1-3' ? '3' : this.selectedMonth
      let params = {
        queryYear: new Date().getFullYear(),
        queryMonth: currentMonth <= 3 ? 3 : month
      }
      extraStyleApi.queryExtraStyleMonthRanking(params).then((response) => {
        if (response.data.resultCode === '0') {
          this.photoList = response.data.resultData.rankingList || []
        }
      })
    },
    initData () {
      const currentMonth = new Date().getMonth() + 1
      this.selectedMonth = currentMonth.toString()
      if (currentMonth <= 3) {
        this.selectedMonth = this.allMonthList[0]
        this.showMonthList.push(this.allMonthList[0])
      } else {
        for (let i = 0; i <= currentMonth - 3 && i < this.allMonthList.length; i++) {
          this.showMonthList.push(this.allMonthList[i])
        }
      }
    },
    hanldeViewPhoto () {
      this.$router.push({ name: 'extra-style-center' })
    },
    hanldeReturnIndex () {
      this.$router.push({ name: 'extra-style' })
    },
    handleSelectedMonth () {
      this.queryPhotoList()
    }
  }
}
</script>

<style lang="less" scoped>
.extra-style-page {
  position: relative;
  width: 100%;
  font-size: 0;
  img {
    width: 100%;
  }
  .center {
    position: absolute;
    top: 50px;
    right: 0;
    width: 80px;
  }
  .container {
    padding-bottom: 10px;
    background: url('../../assets/images/extra-style/bg.jpg') no-repeat;
    background-size: 100% 100%;
    .month-picker {
      position: relative;
      font-size: 14px;
      line-height: 60px;
      text-align: center;
      .arrow-icon {
        position: absolute;
        right: calc(50% - 50px);
        line-height: 60px;
        color: #f5d7a1;
      }
      select {
        height: 30px;
        padding: 0 30px;
        font-weight: 600;
        border-radius: 20px;
        background-image: linear-gradient(#3b8c96, #23565d);
        color: #f5d7a1;
        border: 2px solid #f5d7a1;
        outline: none;
        option {
          line-height: 30px;
          font-size: 12px;
          // background-image: linear-gradient(#3b8c96, #23565d);
          background-color: #3b8c96;
        }
      }
    }
    .no-data {
      padding-top: 50px;
      font-size: 20px;
      text-align: center;
      color: #fff;
    }
    .content {
      position: relative;
      width: 100%;
      min-height: 100px;
      padding-bottom: 10px;
      .template-wrapper {
        width: 80%;
        padding: 10px 2% 0 2%;
        margin: auto;
        margin-bottom: 20px;
        border-radius: 10px;
        font-size: 14px;
        background-color: #fff;
        .ranking-client {
          max-width: 250px;
          line-height: 30px;
          min-height: 80px;
          text-align: left;
          word-break: break-all;
        }
        .ranking-like {
          padding-top: 10px;
          line-height: 30px;
          text-align: left;
        }
        .ranking-like img{
          width: 20px;
        }
      }
      .add-btn {
        z-index: 3;
        position: fixed;
        bottom: 10px;
        right: 10px;
        width: 50px;
      }
    }
    .return-btn {
      padding-top: 10px;
      text-align: center;
      img {
        width: 120px;
      }
    }
  }
}
</style>
